import { createFileRoute, redirect } from '@tanstack/react-router';
import { TaskManagementPage } from '../components/TaskManagementPage';
import { wbsService } from '../services/wbsService';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/tasks')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({ to: '/project-settings/employee-project-models' });
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context;
    await queryClient.prefetchQuery({
      queryKey: ['wbs'],
      queryFn: () => wbsService.getWbs(),
      staleTime: 1000 * 60 * 5,
    });
  },
  component: SettingsTasksComponent,
});

function SettingsTasksComponent() {
  return <TaskManagementPage />;
}
